// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/AssistantAttachments.test.tsx
import { type AskPunttAttachment } from "@mg/schemas/src/christo/askPuntt";
import { Flex } from "@radix-ui/themes";

import { FileAttachmentButton } from "./FileAttachmentButton";
import { ImageWithLoader } from "./ImageWithLoader";

/**
 * The files an assistant answer handed over, beside its text.
 *
 * warhol names a file it made and christo attaches it on the product's media
 * host (`static.puntt.ai`), which checks the viewer's session on every request
 * -- the answer never carries a link that grants access by itself.
 */
export function AssistantAttachments({
  messageId,
  attachments,
}: {
  messageId: string;
  attachments: AskPunttAttachment[] | undefined;
}) {
  if (!attachments?.length) return null;
  return (
    <Flex
      direction="column"
      gap="2"
      data-testid={`assistant-attachments-${messageId}`}
      aria-label="Files from Puntt"
      role="group"
    >
      {attachments.map((attachment) => {
        const name = attachment.name ?? "Attachment";
        return (
          <div key={attachment.key} className="min-w-0">
            {attachment.type === "image" ? (
              <ImageWithLoader
                src={attachment.source}
                alt={name}
                href={attachment.source}
                testId={`assistant-attachment-image-${messageId}-${attachment.key}`}
              />
            ) : (
              <FileAttachmentButton
                url={attachment.source}
                name={name}
                testId={`assistant-attachment-file-${messageId}-${attachment.key}`}
              />
            )}
          </div>
        );
      })}
    </Flex>
  );
}
